//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        props: {
            visibility: {
                type: Boolean,
                default: false,
            },
            dataList: {
                type: Array,
                default: []
            },
            chooseData: {
                type: String,
                default: ''
            },
            showMonth: {
                type: Number,
                default: 3,
            }
        },
        data() {
            return {
                arrDays: [],
                newarrDays: [],
                datasList: this.dataList,
                curData: this.chooseData
            }
        },
        computed:{
            changeData(){
                const { chooseData, dataList} = this
                return {chooseData, dataList }
            }
        },
        watch: {
            changeData(newValue, oldValue) {
                var _this = this;
                _this.datasList = _this.dataList;
                _this.curData = _this.chooseData;
                _this.processData(_this.datasList, _this.arrDays);
            }
        },
        mounted() {
            const date = new Date()
            let month = date.getMonth() + 1;
            const year = date.getFullYear();
            for (let i = 0; i < this.showMonth; i++) {
                if (month > 12) {
                    this.initData(this.formatDate(year + 1, month - 12, 1));
                } else {
                    this.initData(this.formatDate(year, month, 1));
                }
                month += 1
            }
        },
        methods: {
            processData(curData, totalData) {
                if(curData.length > 0){
                    // curData  可选日期
                    let newArr = []
                    let n = 0
                    newArr[n] = [curData[0]]
                    for (let i = 1; i < curData.length; i++) {
                        if (curData[i].curYear == curData[i - 1].curYear && curData[i].curMonth == curData[i - 1].curMonth) {
                            newArr[n].push(curData[i])
                        } else {
                            n++
                            newArr[n] = []
                            newArr[n].push(curData[i])
                        }
                    }
                    var totalArray = []
                    newArr.map((item, index) => {
                        totalArray[index] = {}
                        totalArray[index].newdays = []
                        item.map(text => {
                            totalArray[index].year = text.curYear
                            totalArray[index].month = text.curMonth
                            totalArray[index].newdays.push({
                                'name': text.curDay,
                                'title': text.week,
                                'price': text.salePrice,
                                'data': text.dailyPriceDate,
                                'bookStatus': text.bookStatus,
                                'goodsCode': text.goodsCode ? text.goodsCode : ''
                            })
                            return text
                        })
                        return index
                    })

                    totalData.map((item) => { // 整个日历数据
                        totalArray.map((next) => {
                            if (next.year == item.year && next.month == item.month) {
                                item.newdays.map((items) => {
                                    next.newdays.map((nexts) => {
                                        if (items.name == nexts.name) {
                                            items.title = nexts.title
                                            items.bookStatus = nexts.bookStatus
                                            items.price = nexts.price
                                            items.goodsCode = nexts.goodsCode
                                            //选中日期
                                            if (nexts.data == this.curData) {
                                                items.showActive = true
                                            } else {
                                                items.showActive = false
                                            }
                                        }
                                    })
                                })
                            }
                            return next
                        })
                        item.newdays.map((one, index) => {
                            if (one.name == 1) {
                                item.hid = index - 1
                            }
                            return index
                        })
                        return item
                    })
                    this.newarrDays = totalData
                }
            },
            initData(cur) {
                let self = this
                let date = new Date(cur);
                let currentDay = date.getDate();
                let currentYear = date.getFullYear();
                let currentMonth = date.getMonth() + 1;
                let currentWeek = date.getDay(); // 1...6,0

                let arr = []
                let newArray = []
                let str = this.formatDate(currentYear, currentMonth, currentDay);

                for (let i = currentWeek; i >= 0; i--) {
                    let d = new Date(str);
                    d.setDate(d.getDate() - i);

                    arr.push(d);
                    newArray.push({'name': d.getDate()});
                }
                for (let i = 1; i <= 42 - currentWeek; i++) {

                    let d = new Date(str);
                    
                    d.setDate(d.getDate() + i);

                    if (currentMonth == (d.getMonth() + 1)) {
                        arr.push(d);
                        newArray.push({'name': d.getDate()});
                    }

                }
                let obj = {}
                obj.month = currentMonth
                obj.days = arr
                obj.newdays = newArray
                obj.year = currentYear
                self.arrDays.push(obj)
            },
            formatDate(year, month, day) {
                let y = year;
                let m = month;
                if (m < 10) m = "0" + m;
                let d = day;
                if (d < 10) d = "0" + d;
                return y + "-" + m + "-" + d
            },
            selectDayClick(data, day, balanceNum, goodsCode) {
                let time = this.formatDate(data.year,data.month,day)
                this.$emit('clickDay', time,balanceNum,goodsCode);
            }
        }
    }
